import React from 'react';
import { Button } from 'semantic-ui-react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './InviteFriendButton.scss';

function InviteFriendButton({ className }) {
  return (
    <Button
      className={cx('InviteFriendButton', className)}
      rel="noopener noreferrer"
      target="_blank"
      as="a"
      href="https://www.getmotivatedbuddies.com/referrals"
      icon="mail"
      content="Invite a friend"
    />
  );
}

InviteFriendButton.propTypes = {
  className: PropTypes.string,
};

// TODO: Connect this button to redux to do whatever invite a friend does
export default InviteFriendButton;
